import TraitsAndDimensionsDownloadButton from "@/components/traits/shared/TraitsDownloadButton/TraitsAndDimensionsDownloadButton";
import { Dimension } from "@dimensional-engineering/dimensional-models";
import styles from "./DimensionsLeftBar.module.css";

interface DimensionExtension extends Dimension {
  longDescription: string;
}

type LeftBarProps = {
  dimensionalData: DimensionExtension;
  icon: JSX.Element;
};

export default function DimensionsLeftBar(props: LeftBarProps) {
  return (
    <div className={styles.leftBarMain}>
      <div
        style={{
          backgroundImage: `url(/dimensions/backgrounds/${props.dimensionalData.slug}.jpg)`,
        }}
        className={styles.rectangleParent}
      >
        <div className={styles.iconParent}>{props.icon}</div>
        <h3>{props.dimensionalData.title}</h3>
      </div>
      <div>
        <span className={styles.descTitleDiv}>
          <h4 className={styles.descriptionTitle}>Description</h4>
        </span>
        <p className={styles.description}>
          {props.dimensionalData.longDescription}
        </p>
      </div>
      <div className={styles.buttonDiv}>
        <TraitsAndDimensionsDownloadButton message="Find your score on over 100 traits on Dimensional." />
      </div>
    </div>
  );
}
